export default __webpack_public_path__ + "static/media/all_plugins_optm.cee14657.svg";